// import React, { useState, useRef } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../globals";

// function ServiceMasterForm() {
//   const formRef = useRef(null);

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   const [formData, setFormData] = useState({
//     ServiceName: "",
//     ShortCode: "",
//     HSNCODE: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // const proxyUrl = "https://thingproxy.freeboard.io/fetch/";
//     // const apiUrl = "https://etour.responseinfoway.com/restapi/insertdata.aspx";
//     // const apiUrl = "https://etourrestapi.responseinfoway.com/restApi/insertdata.aspx";
//     const apiUrl = `${BASE_REST_API_URL}/insertdata.aspx`;

//     const data = new FormData();
//     // data.append("SecurityKey", "abcd");
//     data.append("SecurityKey", SECURITY_KEY);
//     data.append("TableName", "ServiceMast");
//     data.append("CompID", "1147");
//     data.append("ServiceName", formData.ServiceName);
//     data.append("ShortCode", "code");
//     data.append("HSNCODE", formData.HSNCODE);
//     data.append("deleted", "1");

//     // Log data
//     for (let [key, value] of data.entries()) {
//       console.log(`${key}: ${value}`);
//     }

//     try {
//       const response = await fetch(apiUrl, {
//         method: "POST",
//         body: data,
//       });

//       const result = await response.json();
//       console.log("API Response:", result);

//       const responseItem = Array.isArray(result?.Response)
//         ? result.Response[0]
//         : result.Response;

//       if (
//         responseItem?.Status === "Success" ||
//         responseItem?.Response === "OK"
//       ) {
//         toast.success("Service data submitted successfully!");
//         setTimeout(() => {
//           window.location.href = "/showservice";
//         }, 1500);
//       } else {
//         toast.success("Service data submitted successfully!");
//         setTimeout(() => {
//           window.location.href = "/showservice";
//         }, 1500);
//       }
//     } catch (err) {
//       console.error("Network or fetch error:", err);
//       toast.error("Network or server error!");
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <form className="compney_form" ref={formRef} onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Service Master</h5>

//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={formData.ServiceName}
//             onChange={handleChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={formData.HSNCODE}
//             onChange={handleChange}
//             placeholder="Enter HSN Code"
//             required
//           />
//         </div>

//         <button type="submit">Submit</button>
//       </form>
//     </div>
//   );
// }

// export default ServiceMasterForm;






// import React, { useState, useRef, useEffect } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../globals";

// function ServiceMaster() {
//   const formRef = useRef(null);

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   const selectedCompID = localStorage.getItem("CompID"); 
  

//   const [formData, setFormData] = useState({
//     ServiceName: "",
//     HSNCODE: "",
//     TaxID: "",
//   });

//   const [taxList, setTaxList] = useState([]);
//   const [selectedTaxRate, setSelectedTaxRate] = useState("");
//   const [taxError, setTaxError] = useState("");

//   // -------------------------------------------------
//   // FETCH TAX LIST BASED ON CompID
//   // -------------------------------------------------
//   useEffect(() => {
//     if (!selectedCompID) return;

//     fetch(`${BASE_API_URL}/api/servicemast/dropdown-tax/${selectedCompID}`)
//       .then(res => res.json())
//       .then(data => {
//         if (!data.status || data.data.length === 0) {
//           setTaxList([]);
//           toast.warning("No taxes found for this company");
//         } else {
//           setTaxList(data.data);
//         }
//       })
//       .catch(err => {
//         console.error("Error loading tax:", err);
//         toast.error("Unable to fetch tax dropdown");
//       });
//   }, [selectedCompID]);

//   // -------------------------------
//   // When TAX dropdown is changed
//   // -------------------------------
//   const handleTaxChange = (e) => {
//     const taxId = Number(e.target.value);
//     const selected = taxList.find(item => item.ID === taxId);

//     setFormData(prev => ({
//       ...prev,
//       TaxID: taxId,
//       TaxName: selected?.TaxName || "", 
//     }));

//     setSelectedTaxRate(selected?.TaxRate || "");
//   };

//   // -------------------------------
//   // INPUT CHANGES
//   // -------------------------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // -------------------------------
//   // SUBMIT
//   // -------------------------------
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const apiUrl = `${BASE_REST_API_URL}/insertdata.aspx`;

//     const data = new FormData();
//     data.append("SecurityKey", SECURITY_KEY);
//     data.append("TableName", "ServiceMast");
//     data.append("CompID", selectedCompID);
//     data.append("ServiceName", formData.ServiceName);
//     data.append("ShortCode", "code");
//     data.append("HSNCODE", formData.HSNCODE);
//     data.append("TaxID", formData.TaxID);
//     data.append("TaxRate", selectedTaxRate);
//     data.append("deleted", "1");

//     try {
//       const response = await fetch(apiUrl, {
//         method: "POST",
//         body: data,
//       });

//       const result = await response.json();

//       const responseItem = Array.isArray(result?.Response)
//         ? result.Response[0]
//         : result.Response;

//       if (responseItem?.Status === "Success" || responseItem?.Response === "OK") {
//         toast.success("Service added successfully!");
//         setTimeout(() => {
//           window.location.href = "/showservice";
//         }, 1500);
//       } else {
//         toast.error("Error saving service!");
//       }
//     } catch (err) {
//       toast.error("Network or server error!");
//       console.error(err);
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <form className="compney_form" ref={formRef} onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Service Master</h5>

//         {/* SERVICE NAME */}
//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={formData.ServiceName}
//             onChange={handleChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         {/* HSN CODE */}
//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={formData.HSNCODE}
//             onChange={handleChange}
//             placeholder="Enter HSN Code"
//             required
//           />
//         </div>

//         {/* TAX DROPDOWN */}
//         <div className="compney_input_div">
//           <label>Tax</label>
//           <select
//             name="TaxID"
//             value={formData.TaxID}
//             onChange={handleTaxChange}
//             required
//           >
//             <option value="">Select Tax</option>
//             {taxList.map(tax => (
//               <option key={tax.ID} value={tax.ID}>
//                 {tax.TaxName} ({tax.TaxRate}%)
//               </option>
//             ))}
//           </select>
//           {taxError && (
//             <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
//               {taxError}
//             </p>
//           )}
//         </div>

//         {/* TAX RATE AUTO-FILL */}
//         <div className="compney_input_div">
//           <label>Tax Rate</label>
//           <input
//             type="text"
//             value={selectedTaxRate}
//             readOnly
//             placeholder="Auto-filled Tax Rate"
//           />
//         </div>

//         <button type="submit">Submit</button>
//       </form>
//     </div>
//   );
// }

// export default ServiceMaster;




// import React, { useState, useRef, useEffect } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../globals";

// function ServiceMaster() {
//   const formRef = useRef(null);

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   // ---------------------------------------------------------
//   // GET Company ID & Company Name from LOCALSTORAGE
//   // ---------------------------------------------------------
//   const [selectedCompID, setSelectedCompID] = useState("");
//   const [selectedCompanyName, setSelectedCompanyName] = useState("");

//   useEffect(() => {
//     const cid = localStorage.getItem("selectedCompanyId");
//     const cname = localStorage.getItem("selectedCompanyName");

//     console.log("📌 Company ID from localStorage =", cid);
//     console.log("📌 Company Name from localStorage =", cname);

//     setSelectedCompID(cid);
//     setSelectedCompanyName(cname);
//   }, []);

//   // ---------------------------------------------------------
//   // FORM STATES
//   // ---------------------------------------------------------
//   const [formData, setFormData] = useState({
//     ServiceName: "",
//     HSNCODE: "",
//     TaxID: "",
//   });

//   const [taxList, setTaxList] = useState([]);
//   const [selectedTaxRate, setSelectedTaxRate] = useState("");

//   // ---------------------------------------------------------
//   // FETCH TAX LIST BASED ON CompID
//   // ---------------------------------------------------------
//   useEffect(() => {
//     if (!selectedCompID) return;

//     console.log("🔍 Fetching tax for CompID =", selectedCompID);

    
//     // fetch(`${BASE_API_URL}/api/servicemast/dropdown-tax/${selectedCompID}`)
//     fetch(`${BASE_API_URL}/servicemast/dropdown-tax/${selectedCompID}`)
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("📌 TAX API RESPONSE =", data);

//         if (!data.status || data.data.length === 0) {
//           setTaxList([]);
//           toast.warning("No taxes found for this company");
//         } else {
//           setTaxList(data.data);
//         }
//       })
//       .catch((err) => {
//         console.error("❌ Error loading tax:", err);
//         toast.error("Unable to fetch tax dropdown");
//       });
//   }, [selectedCompID]);

//   // ---------------------------------------------------------
//   // When TAX dropdown is changed → Auto fill TaxRate
//   // ---------------------------------------------------------
//  const handleTaxChange = (e) => {
//   const taxId = Number(e.target.value);

//   const selected = taxList.find((item) => item.ID === taxId);

//   setFormData((prev) => ({
//     ...prev,
//     TaxID: taxId,
//     TaxName: selected?.TaxName || "",
//   }));

//   setSelectedTaxRate(selected?.TaxRate || "");

//   console.log("📌 Selected TAX =", selected);
// };


//   // ---------------------------------------------------------
//   // INPUT CHANGES
//   // ---------------------------------------------------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // ---------------------------------------------------------
//   // SUBMIT FORM
//   // ---------------------------------------------------------
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   if (!selectedCompID) {
//   //     toast.error("Company not selected!");
//   //     return;
//   //   }

//   //   const apiUrl = `${BASE_REST_API_URL}/insertdata.aspx`;

//   //   const data = new FormData();
//   //   data.append("SecurityKey", SECURITY_KEY);
//   //   data.append("TableName", "ServiceMast");
//   //   data.append("CompID", selectedCompID);
//   //   data.append("ServiceName", formData.ServiceName);
//   //   data.append("ShortCode", "code");
//   //   data.append("HSNCODE", formData.HSNCODE);
//   //   data.append("TaxID", formData.TaxID);
//   //   data.append("TaxRate", selectedTaxRate);
//   //   data.append("deleted", "1");

//   //   try {
//   //     const response = await fetch(apiUrl, {
//   //       method: "POST",
//   //       body: data,
//   //     });

//   //     const result = await response.json();

//   //     const responseItem = Array.isArray(result?.Response)
//   //       ? result.Response[0]
//   //       : result.Response;

//   //     if (responseItem?.Status === "Success" || responseItem?.Response === "OK") {
//   //       toast.success("Service added successfully!");
//   //       setTimeout(() => {
//   //         window.location.href = "/showservice";
//   //       }, 1500);
//   //     } else {
//   //       toast.error("Error saving service!");
//   //     }
//   //   } catch (err) {
//   //     toast.error("Network or server error!");
//   //     console.error(err);
//   //   }
//   // };



//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!selectedCompID) {
//     toast.error("Company not selected!");
//     return;
//   }

//   // Node.js POST API endpoint
//   // const apiUrl = `http://localhost:5000/api/servicemast/add`;
//   const apiUrl = `${BASE_API_URL}/servicemast/add`;

//   // Build JSON payload
//   const payload = {
//     CompID: selectedCompID,
//     ServiceName: formData.ServiceName,
//     ShortCode: formData.ShortCode || "code", // make sure <= DB column length
//     HSNCODE: formData.HSNCODE,
//     Deleted: 0,
//     TaxID: formData.TaxID,
//     TaxRate: selectedTaxRate,
//     TaxName: "", // optional, you can compute or leave empty
//   };

//   console.log("payload")

//   try {
//     const response = await fetch(apiUrl, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(payload),
//     });

//     const result = await response.json();

//     if (result.status) {
//       toast.success("Service added successfully!");
//       setTimeout(() => {
//         window.location.href = "/showservice";
//       }, 1500);
//     } else {
//       toast.error(result.message || "Error saving service!");
//     }
//   } catch (err) {
//     toast.error("Network or server error!");
//     console.error(err);
//   }
// };


//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <form className="compney_form" ref={formRef} onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Service Master</h5>

//         {/* SERVICE NAME */}
//         <div className="compney_input_div">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="ServiceName"
//             value={formData.ServiceName}
//             onChange={handleChange}
//             placeholder="Enter Service Name"
//             required
//           />
//         </div>

//         {/* HSN CODE */}
//         <div className="compney_input_div">
//           <label>HSN Code</label>
//           <input
//             type="text"
//             name="HSNCODE"
//             value={formData.HSNCODE}
//             onChange={handleChange}
//             placeholder="Enter HSN Code"
//             required
//           />
//         </div>

//         {/* TAX DROPDOWN */}
//         <div className="compney_input_div">
//           <label>Tax</label>
//           <select
//             name="TaxID"
//             value={formData.TaxID}
//             onChange={handleTaxChange}
//             required
//           >
//             <option value="">Select Tax</option>

//             {taxList.map((tax) => (
//               <option key={tax.ID} value={tax.ID}>
//                 {tax.TaxName} ({tax.TaxRate}%)
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* AUTO TAX RATE */}
//         <div className="compney_input_div">
//           <label>Tax Rate(%)</label>
//           <input
//             type="text"
//             value={selectedTaxRate}
//             readOnly
//             placeholder="Auto-filled Tax Rate"
//           />
//         </div>
//         <button type="submit">Submit</button>
//       </form>
//     </div>
//   );
// }

// export default ServiceMaster;









import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { showToast } from "../../utils/customToast";
import { SECURITY_KEY } from "../../globals";
import { apiWithLog } from "../../utils/apiWithLog";
import "./Ledger/UpdateLedger.css";

function ServiceMaster() {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);


  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // ---------------------------------------------------------
  // GET Company ID & Company Name from LOCALSTORAGE
  // ---------------------------------------------------------
  const [selectedCompID, setSelectedCompID] = useState("");
  const [selectedCompanyName, setSelectedCompanyName] = useState("");

  // 🔹 ADDED: load company + listen to changes (NO REFRESH)
  useEffect(() => {
    const loadCompany = () => {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));

      if (company?.id) {
        console.log("📌 Company changed →", company);
        setSelectedCompID(company.id);
        setSelectedCompanyName(company.name);
      } else {
        setSelectedCompID("");
        setSelectedCompanyName("");
      }
    };

    loadCompany();

    // same-tab listener
    const onCompanyChange = () => loadCompany();
    window.addEventListener("companyChanged", onCompanyChange);

    // cross-tab listener
    const onStorageChange = (e) => {
      if (e.key === "selectedCompany") loadCompany();
    };
    window.addEventListener("storage", onStorageChange);

    return () => {
      window.removeEventListener("companyChanged", onCompanyChange);
      window.removeEventListener("storage", onStorageChange);
    };
  }, []);

  // ---------------------------------------------------------
  // FORM STATES
  // ---------------------------------------------------------
  const [formData, setFormData] = useState({
    ServiceName: "",
    HSNCODE: "",
    TaxID: "",
    Unit: "",
  });

  const [taxList, setTaxList] = useState([]);
  const [selectedTaxRate, setSelectedTaxRate] = useState("");

  // ---------------------------------------------------------
  // FETCH TAX LIST BASED ON CompID
  // ---------------------------------------------------------
  useEffect(() => {
    if (!selectedCompID) return;

    console.log("🔍 Fetching tax for CompID =", selectedCompID);

    fetch(`${BASE_API_URL}/servicemast/dropdown-tax/${selectedCompID}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("📌 TAX API RESPONSE =", data);

        if (!data.status || data.data.length === 0) {
          setTaxList([]);
          showToast.warn("No taxes found for this company");
        } else {
          setTaxList(data.data);
        }
      })
      .catch((err) => {
        console.error("❌ Error loading tax:", err);
        showToast.error("Unable to fetch tax dropdown");
      });
  }, [selectedCompID]);

  // ---------------------------------------------------------
  // When TAX dropdown is changed → Auto fill TaxRate
  // ---------------------------------------------------------
  const handleTaxChange = (e) => {
    const taxId = Number(e.target.value);

    const selected = taxList.find((item) => item.ID === taxId);

    setFormData((prev) => ({
      ...prev,
      TaxID: taxId,
      TaxName: selected?.TaxName || "",
    }));

    setSelectedTaxRate(selected?.TaxRate || "");
  };

  // ---------------------------------------------------------
  // INPUT CHANGES
  // ---------------------------------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!selectedCompID) {
      showToast.error("Company not selected!");
      return;
    }

    const payload = {
      CompID: selectedCompID,
      ServiceName: formData.ServiceName,
      ShortCode: formData.ShortCode || "code",
      HSNCODE: formData.HSNCODE,
      Deleted: 0,
      TaxID: formData.TaxID,
      TaxRate: selectedTaxRate,
      TaxName: formData.TaxName || "",
      Unit: formData.Unit || "",
    };

    console.log("📦 Payload =", payload);

    try {
      setLoading(true);

      const res = await apiWithLog({
        method: "POST",
        url: `${BASE_API_URL}/servicemast/add`,
        data: payload,
        module: "ServiceMaster",
        action: "A",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;

      if (res.status === 200 && result?.status) {
        showToast.save(`Service added for ${selectedCompanyName}`);

        setTimeout(() => {
          window.location.href = "/showservice";
        }, 1200);
      } else {
        showToast.error(result?.message || "Error saving service!");
      }
    } catch (error) {
      console.error("Add Service Error:", error);
      showToast.error(
        error?.response?.data?.message ||
        "Network or server error!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Add Service</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/showservice">Services</Link>
            <span>/</span>
            <span>New</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Service Details</h5>
        </div>

        <form ref={formRef} onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            {/* SERVICE NAME */}
            <div className="update_ledger_field">
              <label htmlFor="ServiceName">
                Service Name <span className="required">*</span>
              </label>
              <input
                id="ServiceName"
                type="text"
                name="ServiceName"
                value={formData.ServiceName}
                onChange={handleChange}
                placeholder="Enter Service Name"
                required
              />
            </div>

            {/* HSN CODE */}
            <div className="update_ledger_field">
              <label htmlFor="HSNCODE">HSN Code</label>
              <input
                id="HSNCODE"
                type="text"
                name="HSNCODE"
                value={formData.HSNCODE}
                onChange={handleChange}
                placeholder="e.g. 9964"
              />
            </div>

            {/* TAX DROPDOWN */}
            <div className="update_ledger_field">
              <label htmlFor="TaxID">Tax</label>
              <select
                id="TaxID"
                name="TaxID"
                value={formData.TaxID}
                onChange={handleTaxChange}
              >
                <option value="">-- Select Tax --</option>
                {taxList.map((tax) => (
                  <option key={tax.ID} value={tax.ID}>
                    {tax.TaxName} ({tax.TaxRate}%)
                  </option>
                ))}
              </select>
            </div>

            {/* AUTO TAX RATE */}
            <div className="update_ledger_field">
              <label htmlFor="TaxRate">Tax Rate (%)</label>
              <input
                id="TaxRate"
                type="text"
                value={selectedTaxRate}
                readOnly
                placeholder="Auto-filled Tax Rate"
              />
            </div>

            {/* UNIT */}
            <div className="update_ledger_field">
              <label htmlFor="Unit">Default Unit</label>
              <select
                id="Unit"
                name="Unit"
                value={formData.Unit}
                onChange={handleChange}
              >
                <option value="">-- Select Unit --</option>
                <option value="Trip">Trip</option>
                <option value="Day">Day</option>
                <option value="Lump Sum">Lump Sum</option>
                <option value="No.">No.</option>
                <option value="Month">Month</option>
                <option value="Km">Km</option>
                <option value="Hr">Hr</option>
              </select>
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/showservice" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Service"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ServiceMaster;
